import { useEffect } from "react";
import PageLayout from "@/components/feature/PageLayout";
import HeroSection from "./components/HeroSection";
import BusinessSection from "./components/BusinessSection";
import VoiceSection from "./components/VoiceSection";
import FlowPreview from "./components/FlowPreview";
import DiagnosisSection from "./components/DiagnosisSection";
import CtaSection from "./components/CtaSection";
import HomeFooter from "./components/HomeFooter";

export default function Home() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    const els = document.querySelectorAll(".reveal, .reveal-left, .reveal-right");
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <PageLayout>
      <HeroSection />
      <BusinessSection />
      <VoiceSection />
      <FlowPreview />
      <DiagnosisSection />
      <CtaSection />
      <HomeFooter />
    </PageLayout>
  );
}